export default ({...props}) => {
  const {size, space} = props.theme
  return `
	width: ${size(12.5)}%;
	height: ${size(40)}px;
	position: relative;
  margin-bottom: ${space(2)}px;

  @media only screen and (max-width: 425px) {
    width: calc(${space(12.5)}% + ${size(5)}px);
    right: ${space(2.5)}px;
    .H_l_right {
      right: ${space(12.5)}%;
    }
  }

  & > div {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
  }
  & .H_copyright {
    pointer-events: all;
  }`
}
